<template>
  <div class="my-result">
    <div class="icon">
      <i :class="iconClass" v-if="icon"></i>
    </div>
    <div class="title">{{ title }}</div>
    <div class="sub-title">{{ subTitle }}</div>
      <div class="sub-title">{{ subTitle1 }}</div>
    <div class="extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyResult',
  props: {
    icon: {
      type: String,
      default: 'success'
    },
    title: {
      type: String,
      default: '注册成功'
    },
    subTitle: {
      type: String,
      default: '请复制网址到PC端登录使用，开启轻松备考之旅!'
    },
    subTitle1: {
      type: String,
      default: ''
    }
  },
  mounted(){
  const fullUrl = window.location.href;
      const domain = fullUrl.split("#")[0] ;
      this.subTitle1+=domain+"#/login";
       
  },
  computed: {
    iconClass() {
      return `el-icon-${this.icon}`;
    }
  }
};
</script>

<style scoped>
.my-result {
  text-align: center;
  padding: 40px;
}
.icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.sub-title {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}
.extra {
  margin-top: 20px;
}
</style>